import { render } from "./detail.vue?vue&type=template&id=201518c4"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/vab/table/detail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "201518c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('201518c4', __exports__)) {
    console.log('reload')
    api.reload('201518c4', __exports__)
  }
  
  module.hot.accept("./detail.vue?vue&type=template&id=201518c4", () => {
    console.log('re-render')
    api.rerender('201518c4', render)
  })

}


export default __exports__